import { useState } from 'react'
import {
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useGetPurposesQuery
} from 'prove-common'
import { PurposesTable } from '../tables/purposes-table/PurposesTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { PurposeForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const PurposesScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const { data: purposes, isFetching, isError, refetch } = useGetPurposesQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Hensikter' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Hensikter'
            description='Hensikter beskriver hvorfor prøver tas. Systemhensikten OK-program er beskyttet.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til hensikt
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={purposes != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {purposes ? <PurposesTable purposes={purposes} /> : null}
      </ScreenLayout>
      {isModalOpen && <PurposeForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
